import React, { Component } from 'react';
import { Form, FormGroup, FormFeedback, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';

const CURRENT_HELP = `
  <div>
    <p><strong>Purpose:</strong> The current access method just means whether the client has any access to a device already, right now.  
    For example, a client may still be using an access method they got 10 years ago, even though it’s not working as well for them as it once did.   
    </p>
    <p>Talking about any current access methods helps you and the client understand what problems need to be solved.  
    And the current access methods form a baseline that can be used for comparisons with any new access methods you decide to try. 
    </p>
    <p>You can include as many current access methods as you want. These should be methods that the client uses regularly.  
    In a separate section, you’ll have a chance to enter methods that the client may have tried before but no longer uses.  
    </p>
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  methodName: PropTypes.string, 
  onChangeMethodName: PropTypes.func.isRequired,
  methodNotes: PropTypes.string, 
  onChangeMethodNotes: PropTypes.func.isRequired,
  methodNameError: PropTypes.string,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  methodName: '',
  methodNotes: '',
  methodNameError: ''
};

//content sub-component with unique content for this page
class CurrentMethodEntryForm extends Component {
  constructor(props){
    super(props);
  }

  //Render the form for entering current method info.
  //Calls the setter that's passed in by the parent, when user types.
  //That setter changes the state of the method vars in the parent, 
  //which triggers a new render of the view.
  render(){
    const methodName = this.props.methodName;
    const onChangeMethodName = this.props.onChangeMethodName;
    const methodNameError = this.props.methodNameError;
    const methodNotes = this.props.methodNotes;
    const onChangeMethodNotes = this.props.onChangeMethodNotes;
    const onSubmit = this.props.onSubmit;

    console.log("form methodName: " + methodName);
    console.log("form methodNotes: " + methodNotes);

    return(
    <>
    {/* TODO Resolve. currently supports hitting Enter to submit (Continue) 
    https://ux.stackexchange.com/questions/130603/which-is-best-for-an-enter-note-field-an-enter-button-or-hitting-the-return-k
    Based on traditions of user interfaces, most users probably expect to press Enter OR 
    click a Save button to enter text in a field. 
    Giving both options often makes the most sense. 
    On the other hand, if saving the text also sends you to another screen, 
    then you want to prevent accidental actions, probably by not allowing Enter, 
    and by labeling the button "Save and Close" or "Save and Exit" or similar.
    */}
    <Form onSubmit={onSubmit}>
      <FormGroup>
        <Label for="method-name">
          Name of current method:
        </Label>
        <Input
          id="method-name"
          value={methodName}
          onChange={onChangeMethodName}
          name="method-name"
          type="text"
          invalid={methodNameError !== ''}
        />
        <FormFeedback>{methodNameError}</FormFeedback>
      </FormGroup>
      <FormGroup>
        <Label for="method-notes">
          How are things going with this method?
        </Label>
        <Input
          id="method-notes"
          value={methodNotes}
          onChange={onChangeMethodNotes}
          name="method-notes"
          placeholder="briefly describe experiences to date with this method"
          type="textarea"
        />
      </FormGroup>
      {' '}
    </Form>
    </>
  );
}
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function GatherInfoHistoryCurrentMethodEntry(props) {
  const firstName = props.firstName;
  const pronouns = props.pronouns;
  const methodName = props.methodName;
  const onChangeMethodName = props.onChangeMethodName;
  const methodNameError = props.methodNameError;
  const methodNotes = props.methodNotes;
  const onChangeMethodNotes = props.onChangeMethodNotes;
  const onContinue = props.onContinue;

  // console.log("rendering CurrentMethodEntry: " + methodName);
  // console.log("rendering CurrentMethodEntry. callback type:  " + typeof(onChangeMethodName));

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used
    faIcon: "fa-clock-o",
    pageSymbolClassName: "aa-section-symbol gather",
    title: `Tell us about this access method`,
    subTitle: `This should be a method that ${firstName} uses or practices with at least sometimes.`,
    learnMore: {linkText: "Learn More about what we mean by a current access method and why it matters",
                title: "Current Access Method",
                content: CURRENT_HELP
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: true,
    backName: 'Cancel',
    continueName: 'Done'
  }

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <CurrentMethodEntryForm 
          firstName={firstName} 
          pronouns={pronouns}
          methodName={methodName} 
          onChangeMethodName={onChangeMethodName}
          methodNameError={methodNameError}
          methodNotes={methodNotes} 
          onChangeMethodNotes={onChangeMethodNotes}
          onSubmit={onContinue}
        />
      }
      onContinue={onContinue} 
    />
    </>
  );
}

GatherInfoHistoryCurrentMethodEntry.propTypes = propTypes;
GatherInfoHistoryCurrentMethodEntry.defaultProps = defaultProps;

export default GatherInfoHistoryCurrentMethodEntry;